var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContactBook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "Contact_1_",
    d: "m32 256c0-8.844 7.156-16 16-16h32c8.844 0 16 7.156 16 16s-7.156 16-16 16h-32c-8.844 0-16-7.156-16-16zm16-128h32c8.844 0 16-7.156 16-16s-7.156-16-16-16h-32c-8.844 0-16 7.156-16 16s7.156 16 16 16zm432-80v416c0 26.468-21.532 48-48 48h-320c-26.468 0-48-21.532-48-48v-32h16c17.672 0 32-14.328 32-32s-14.328-32-32-32h-16v-80h16c17.672 0 32-14.328 32-32s-14.328-32-32-32h-16v-80h16c17.672 0 32-14.328 32-32s-14.328-32-32-32h-16v-32c0-26.468 21.532-48 48-48h320c26.468 0 48 21.532 48 48zm-240 144c0 26.508 21.492 48 48 48s48-21.492 48-48-21.492-48-48-48-48 21.492-48 48zm144 144c0-35.348-28.652-64-64-64h-64c-35.348 0-64 28.652-64 64v16c0 17.672 14.328 32 32 32h128c17.672 0 32-14.328 32-32zm-288 64c0-8.844-7.156-16-16-16h-32c-8.844 0-16 7.156-16 16s7.156 16 16 16h32c8.844 0 16-7.156 16-16z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactBook);
export default __webpack_public_path__ + "static/media/contact-book.559ef4da2e1a1d26d8bd699dd3adb316.svg";
export { ForwardRef as ReactComponent };